import { Box, Text } from '@rbilabs/universal-components';

export const ProductInformationContainer = Box.withConfig({
  accessible: true,
  focusable: true,
  paddingX: { base: '$4', md: '$0' },
  marginTop: {
    base: '$4',
    md: '$8',
  },
});

export const ProductInformationTitle = Text.withConfig({
  variant: 'headerThree',
  marginY: '$4',
});

export const ProductInformationDescription = Text.withConfig({ variant: 'copyTwo' });
